import type { AdminExhibitionPurpose } from '@repo/api-contracts';
import { type MutationError, trpc } from '@/shared/api';

interface UseCreateExhibitionPurposeOptions {
  /** 만들어진 목적을 받아 새 탭을 바로 선택하는 데 쓴다. */
  readonly onSuccess?: (purpose: AdminExhibitionPurpose) => void;
}

/** 목적 탭을 맨 뒤에 추가한다. 이름이 겹치면 서버가 거부한다. */
export const useCreateExhibitionPurpose = ({
  onSuccess,
}: UseCreateExhibitionPurposeOptions = {}) => {
  const mutation = trpc.productManagement.exhibitionPurposes.create.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    createPurpose: (name: string) => mutation.mutate({ name }),
    isPending: mutation.isPending,
    error,
    reset: mutation.reset,
  };
};
